import { isMobile } from '@/utils/util';
import React from 'react';

interface StarRatingProps {
  rating: number;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const filledStars = Math.min(rating, 4); // 实心星星数量
  const emptyStars = 4 - filledStars; // 空心星星数量

  return (
    <div style={{ fontSize: ( isMobile() ? '0.26rem' : '24px') }}>
      {Array(filledStars)
        .fill(null)
        .map((_, index) => (
          <span key={index} style={{ color:'#C6B782' }}>&#9733;</span>
        ))}


      {Array(emptyStars)
        .fill(null)
        .map((_, index) => (
          <span key={index} style={{ color:'#C6B782' }}>&#9734;</span>
        ))}
    </div>
  );
};

export default StarRating;